import _ from 'lodash';
import { createSelector } from 'reselect';
import { getUserMap } from './user-selectors';

const getFollowingState = state => state.following;
const getIdList = state => getFollowingState(state).idList;
const getMetadata = state => getFollowingState(state).metadata;

export const getFollowing = createSelector([getIdList, getUserMap], (followerIds, users) =>
  _.map(followerIds, followerId => users[followerId])
);

export const getFollowerCount = state => _.get(getMetadata(state), 'count', 0);



// WEBPACK FOOTER //
// ./app/selectors/following-selectors.js